import { HelpCircle, ArrowRight } from "lucide-react";
import { useHelp } from "../../lib/help";

export default function EmptyState({
  icon: Icon,
  title = "Nothing here yet",
  description = "Get started by recording your first entry below.",
  helpTopic,
  helpText = "How this works & IRS rules",
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  className = "",
  testId = "empty-state-card",
}) {
  const { openHelp } = useHelp();

  return (
    <div
      className={`card p-8 sm:p-12 text-center flex flex-col items-center justify-center max-w-xl mx-auto my-6 border-dashed border-[var(--border)] bg-[var(--surface-hover)]/30 ${className}`}
      data-testid={testId}
    >
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#1C3A5E]/20 to-[#0D9488]/20 border border-teal-500/20 text-teal-400 flex items-center justify-center mb-4 shadow-sm">
          <Icon size={26} />
        </div>
      )}

      <h3 className="text-base sm:text-lg font-bold text-[var(--text)] mb-1.5">
        {title}
      </h3>

      <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400 max-w-md leading-relaxed mb-4">
        {description}
      </p>

      <div className="flex flex-col sm:flex-row items-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="btn-primary text-xs py-2 px-4 shadow-md"
            data-testid={`${testId}-action`}
          >
            {actionLabel}
          </button>
        )}

        {secondaryActionLabel && onSecondaryAction && (
          <button
            type="button"
            onClick={onSecondaryAction}
            className="btn-secondary text-xs py-2 px-4"
            data-testid={`${testId}-secondary-action`}
          >
            {secondaryActionLabel}
          </button>
        )}

        {helpTopic && (
          <button
            type="button"
            onClick={() => openHelp(helpTopic)}
            className="text-xs font-semibold text-teal-400 hover:text-teal-300 flex items-center gap-1 py-1.5 px-3 rounded-xl border border-teal-500/30 hover:bg-teal-500/10 transition-colors"
            data-testid={`${testId}-help`}
          >
            <HelpCircle size={14} />
            <span>{helpText}</span>
            <ArrowRight size={12} />
          </button>
        )}
      </div>
    </div>
  );
}
